// extracted by mini-css-extract-plugin
export default {"control":"CarsCheckout_control__MJXHz","wrapper":"CarsCheckout_wrapper__73q+h","confirm":"CarsCheckout_confirm__X5yoJ","price":"CarsCheckout_price__+iw6W"};